<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JrEPOj/tc-custom/FC-9781528985536.jpg?1684870885593?1709062252278" alt="This image is the cover for the book Don't Do It, She Likes It"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Don't Do It, She Likes It
      </h1>
      <p class="bookDescription body article font2">
        <p>If you read this, this is a story about you, written by you, from you and for you. As we know social media has changed the world, it is not just part of your life but it is your life. Social media motto: do not judge, lest be judged with photoshopped and filtered photos. Social media is so powerful, it can turn nice guys into thugs, strangers into lovers, and your milkman into lover (and vice versa). What you post there is limitless – duck face selfies, possum face selfies, egg holder mouth selfies (all photoshopped). The limits are your internet connection and if your partner finds out your passwords (are you in cold sweat now?) Come and discover the good, the bad and the funny side of social media – where you can see what everyone’s bathroom looks like…</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susu Smitzh
      </h2>
      
      <p class="authorDescription body article">Susu Smitzh was born and grew up in South Asia, now living in Sydney, Australia. She is married and a mother of a daughter. She likes drawing, sudoku, watching documentaries, cooking and 50% discounts. This is her very first book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?30127c32